export interface BalanceResponse {
  balance: string; // BigInt as string
  userId: string;
}

export interface TransactionResponse {
  createdAt: string; // ISO date string
  description: string | null;
  isStripeOriginated: boolean;
  pointsAmount: string; // BigInt as string, negative for deductions
  transactionId: string;
  userId: string;
}

export interface TransactionHistoryResponse {
  data: TransactionResponse[];
  total: number;
}

export interface AdminAdjustPointsRequest {
  amount: number; // Positive integer only
  description: string;
  userId: string;
}

export enum TransactionType {
  ADMIN_ADD = "Admin Add",
  ADMIN_DEDUCT = "Admin Deduct",
  STRIPE_PAYMENT = "Stripe Payment",
  STRIPE_REFUND = "Refund",
}

export interface TransactionDisplay extends TransactionResponse {
  formattedAmount: string;
  isPositive: boolean;
  type: TransactionType;
}
